"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var cabin_category_1 = require("./cabin_category");
var helper_1 = require("./helper");
var state_1 = require("./state");
// set the list of cabinCategories
function SET_CABIN_CATEGORIES(state, params) {
    var cabins = lodash_1.map(params.cclist, function (item) {
        var additionalItems = lodash_1.filter(params.additionalCCList, function (aitem) {
            return aitem.mainID === item.mainID;
        });
        var additionalVarioAIItem = lodash_1.filter(params.varioAICategories, function (aitem) {
            return aitem.mainID === item.mainID;
        });
        // return if item.code is there (cabincategory seems to be in a good shape)
        // return if item.code is missing and we cant
        // do anything about it (no premium categories for filling out the holes)
        if (!item.id && !additionalItems) {
            return new cabin_category_1.CabinCategory(item, null, null, params.shipCode);
        }
        if (item.id) {
            //console.log('add items', additionalItems)
            return new cabin_category_1.CabinCategory(item, additionalItems, additionalVarioAIItem, params.shipCode);
        }
        // ugly hack, filling vario data with additional data
        var additional = lodash_1.cloneDeep(additionalItems); //cloneDeep(premiumItems) //cloneDeep(item.premiumCategories)
        var itemCopy = lodash_1.cloneDeep(item);
        itemCopy.available = false;
        // note premium is a copy no mutating original data here
        var merged = lodash_1.merge(additional[0], itemCopy);
        // merged.id is problematic, but shouldnt be used
        merged.mainID = item.mainID; // to be sure
        delete merged['head'];
        return new cabin_category_1.CabinCategory(merged, additionalItems, additionalVarioAIItem, params.shipCode);
    });
    // Sorting of our main categories. If we dont support premium in the current price model
    // the have to be sorted down.
    var cabCats = lodash_1.partition(cabins, function (cabin) {
        if (state.priceModelSupportsPremium) {
            return (cabin.available || cabin.premiumAvailable || cabin.premiumAIAvailable);
        }
        if (state.varioAISupport && state.priceModelSupportsPremium) {
            return cabin.available || cabin.varioAIAvailable || cabin.premiumAvailable || cabin.premiumAIAvailable;
        }
        return cabin.available;
    });
    state.cabinCategories = lodash_1.cloneDeep(lodash_1.concat(lodash_1.sortBy(cabCats[0], function (cabin) {
        if (cabin.available) {
            return cabin.price;
        }
        // depending on priceModelsupport etc. this only can be a valid premium or premiumAI price
        if (cabin.premiumAvailable) {
            return cabin.cheapestPremiumPrice;
        }
        return cabin.cheapestPremiumAIPrice;
    }), lodash_1.sortBy(cabCats[1], function (cabin) {
        return cabin.price ? cabin.price : Infinity;
    })));
    var selectionCategoryConfigurations = lodash_1.cloneDeep(state.selectionCategoryConfigurations);
    // init selectionCategoryConfigurations
    for (var _i = 0, _a = state.cabinCategories; _i < _a.length; _i++) {
        var cabinCategorie = _a[_i];
        var cabinCategory = cabinCategorie;
        var mainCategoryCode = cabinCategory.mainCode;
        if (!lodash_1.find(state.selectionCategoryConfigurations, {
            mainCategory: mainCategoryCode,
        })) {
            // premiumCategoryConfiguration not yet existent
            selectionCategoryConfigurations.push(new state_1.SelectionCategoryConfiguration(mainCategoryCode));
        }
    }
    state.selectionCategoryConfigurations = selectionCategoryConfigurations;
    function setPriceDiffer(collection, priceDiffer) {
        var cabin = lodash_1.find(collection, function (c) {
            return c.code === priceDiffer.cabinCategoryCode;
        });
        if (cabin) {
            cabin.price = priceDiffer.price;
        }
    }
    for (var _b = 0, _c = state.priceDiffers; _b < _c.length; _b++) {
        var pd = _c[_b];
        setPriceDiffer(state.cabinCategories, pd);
        for (var _d = 0, _e = state.cabinCategories; _d < _e.length; _d++) {
            var cabinCategory = _e[_d];
            if (cabinCategory.premiumCategories) {
                setPriceDiffer(cabinCategory.premiumCategories, pd);
            }
        }
    }
    if (state.cabinCategory) {
        // reset so if cabin is not available anymore it gets deleted
        // TODO also reselect sub category ?
        SELECT_MAIN_CABIN_CATEGORY(state, {
            code: state.cabinCategory,
            activeAdditionalCategory: state.activeAdditionalCategory,
        });
    }
}
exports.SET_CABIN_CATEGORIES = SET_CABIN_CATEGORIES;
function SET_AVAILABLE_CABIN_CATEGORIES(state, cabinCategories) {
    state.availableCabinCategories = cabinCategories;
}
exports.SET_AVAILABLE_CABIN_CATEGORIES = SET_AVAILABLE_CABIN_CATEGORIES;
function SET_CABINS(state, opts) {
    var listIndex = lodash_1.findIndex(state.cabins, { category: opts.args.cabinCategory });
    if (listIndex === -1) {
        state.cabins.push({
            category: opts.args.cabinCategory,
            cabins: opts.cabins,
            decks: opts.decks,
        });
    }
    else {
        state.cabins[listIndex].cabins = opts.cabins;
        state.cabins[listIndex].decks = opts.decks;
    }
}
exports.SET_CABINS = SET_CABINS;
function SET_DECKS(state, decks) {
    state.decks = decks;
}
exports.SET_DECKS = SET_DECKS;
// set the price of the selected cabinCategory directly, for handling priceDiffers
// TODO this logic could be broken..
function SET_CABIN_CATEGORY_PRICE(state, input) {
    // objects are passed by reference. should work
    state.priceDiffers.push({
        cabinCategoryCode: input.category.code,
        price: input.value,
        priceOld: lodash_1.clone(input.category.price),
    });
    input.category.price = input.value;
}
exports.SET_CABIN_CATEGORY_PRICE = SET_CABIN_CATEGORY_PRICE;
// choose a cabinCategory, represented by it's code, can select available: false
function SELECT_MAIN_CABIN_CATEGORY(state, input) {
    var cabin = lodash_1.find(state.cabinCategories, {
        mainCode: input.code,
    });
    if (cabin) {
        state.cabinCategory = cabin.mainCode;
        state.activeAdditionalCategory = input.activeAdditionalCategory;
    }
    else {
        state.cabinCategory = null;
        //TODO: premiumAI?
        //state.activeAdditionalCategory = 'NONE'
    }
}
exports.SELECT_MAIN_CABIN_CATEGORY = SELECT_MAIN_CABIN_CATEGORY;
function SET_MAIN_CABIN_CATEGORIES(state, mainCabinCategories) {
    state.mainCabinCategories = mainCabinCategories;
}
exports.SET_MAIN_CABIN_CATEGORIES = SET_MAIN_CABIN_CATEGORIES;
// set the currently requested URL to prevent re-fetching and concurrency issues
function SET_LOADING_CABIN_CATEGORIES(state, key) {
    state.loadingCabinCategories = key;
}
exports.SET_LOADING_CABIN_CATEGORIES = SET_LOADING_CABIN_CATEGORIES;
function SET_LOADING_CABINS(state, key) {
    state.loadingCabins = key;
}
exports.SET_LOADING_CABINS = SET_LOADING_CABINS;
function SET_LOADING_WISH_CABIN(state, key) {
    state.loadingWishCabin = key;
}
exports.SET_LOADING_WISH_CABIN = SET_LOADING_WISH_CABIN;
function SET_ACTIVE_ADDITIONAL_CATEGORY_STATE(state, activeAdditionalCategoryValue) {
    state.activeAdditionalCategory = activeAdditionalCategoryValue;
}
exports.SET_ACTIVE_ADDITIONAL_CATEGORY_STATE = SET_ACTIVE_ADDITIONAL_CATEGORY_STATE;
function SET_SELECTION_CATEGORY_CONFIGURATION(state, configuration) {
    var configurations = lodash_1.cloneDeep(state.selectionCategoryConfigurations);
    var cIndex = lodash_1.findIndex(configurations, {
        mainCategory: configuration.mainCategory,
    });
    configurations[cIndex] = configuration;
    state.selectionCategoryConfigurations = configurations;
}
exports.SET_SELECTION_CATEGORY_CONFIGURATION = SET_SELECTION_CATEGORY_CONFIGURATION;
function SET_PREMIUM_CABIN_CATEGORY(state, premiumCode) {
    // TODO: Add available check
    var premiumIndex = helper_1.default.getCurrentSelectionConfigurationIndex(state);
    state.selectionCategoryConfigurations[premiumIndex].subCategory = premiumCode;
}
exports.SET_PREMIUM_CABIN_CATEGORY = SET_PREMIUM_CABIN_CATEGORY;
function SET_PREMIUM_CABIN_SHIP_SECTION(state, section) {
    var premiumIndex = helper_1.default.getCurrentSelectionConfigurationIndex(state);
    state.selectionCategoryConfigurations[premiumIndex].shipSection = section;
}
exports.SET_PREMIUM_CABIN_SHIP_SECTION = SET_PREMIUM_CABIN_SHIP_SECTION;
function SET_PREMIUM_CABIN_DECK(state, deck) {
    // TODO: Add available check
    var premiumIndex = helper_1.default.getCurrentSelectionConfigurationIndex(state);
    state.selectionCategoryConfigurations[premiumIndex].deck = deck;
}
exports.SET_PREMIUM_CABIN_DECK = SET_PREMIUM_CABIN_DECK;
function SET_PREMIUM_CABIN_CABIN(state, cabin) {
    // TODO: Add available check
    var premiumIndex = helper_1.default.getCurrentSelectionConfigurationIndex(state);
    state.selectionCategoryConfigurations[premiumIndex].cabin = cabin;
}
exports.SET_PREMIUM_CABIN_CABIN = SET_PREMIUM_CABIN_CABIN;
function SET_PREMIUM_CABIN_STEP(state, step) {
    var premiumIndex = helper_1.default.getCurrentSelectionConfigurationIndex(state);
    state.selectionCategoryConfigurations[premiumIndex].currentStep = step;
}
exports.SET_PREMIUM_CABIN_STEP = SET_PREMIUM_CABIN_STEP;
function SET_PREMIUM_CABIN_STEP_NEXT(state) {
    var premiumIndex = helper_1.default.getCurrentSelectionConfigurationIndex(state);
    var newStep = 'PS';
    switch (state.selectionCategoryConfigurations[premiumIndex].currentStep) {
        case 'PS':
            newStep = 'SC';
            break;
        case 'SC':
            newStep = 'SS';
            break;
        case 'SS':
            newStep = 'CS';
            break;
        case 'CS':
            newStep = 'CS';
            break;
        default:
            newStep = 'PS';
            break;
    }
    state.selectionCategoryConfigurations[premiumIndex].currentStep = newStep;
}
exports.SET_PREMIUM_CABIN_STEP_NEXT = SET_PREMIUM_CABIN_STEP_NEXT;
function SET_PREMIUM_CABIN_STEP_PREVIOUS(state) {
    // TODO: Add available check
    var premiumIndex = helper_1.default.getCurrentSelectionConfigurationIndex(state);
    var newStep = 'PS';
    switch (state.selectionCategoryConfigurations[premiumIndex].currentStep) {
        case 'PS':
            newStep = 'PS';
            break;
        case 'SS':
            newStep = 'SC';
            break;
        case 'CS':
            newStep = 'SS';
            break;
        case 'SC':
            newStep = 'PS';
            break;
        default:
            newStep = 'PS';
            break;
    }
    state.selectionCategoryConfigurations[premiumIndex].currentStep = newStep;
}
exports.SET_PREMIUM_CABIN_STEP_PREVIOUS = SET_PREMIUM_CABIN_STEP_PREVIOUS;
function SET_LOADING_REQUIRED_CABIN_INFO(state, info) {
    if (!info) {
        state.loadingRequiredCabin.cabinNumber = null;
        return;
    }
    state.loadingRequiredCabin = info;
}
exports.SET_LOADING_REQUIRED_CABIN_INFO = SET_LOADING_REQUIRED_CABIN_INFO;
function SET_LOADING_REQUIRED_CABIN_WAS_SCROLLED(state) {
    state.loadingRequiredCabin.lastFoundCabinNumberForScrollingIntoView = null;
}
exports.SET_LOADING_REQUIRED_CABIN_WAS_SCROLLED = SET_LOADING_REQUIRED_CABIN_WAS_SCROLLED;
// whichOne searches for subCategory, not for mainConfig
function REMOVE_USER_SELECTIONS(state, whichOne) {
    function resetConfig(config) {
        config.cabin = null;
        config.deck = null;
        config.shipSection = null;
        config.subCategory = null;
        config.currentStep = 'PS';
    }
    switch (whichOne) {
        case 'PREMIUM_CONFIGURATIONS':
            for (var _i = 0, _a = state.selectionCategoryConfigurations; _i < _a.length; _i++) {
                var config = _a[_i];
                resetConfig(config);
            }
            break;
        case undefined:
            for (var _b = 0, _c = state.selectionCategoryConfigurations; _b < _c.length; _b++) {
                var config = _c[_b];
                resetConfig(config);
            }
            state.activeAdditionalCategory = 'NONE';
            state.cabinCategory = null;
            break;
        default:
            for (var _d = 0, _e = state.selectionCategoryConfigurations; _d < _e.length; _d++) {
                var config = _e[_d];
                if (config.subCategory === whichOne) {
                    continue;
                }
                resetConfig(config);
            }
    }
}
exports.REMOVE_USER_SELECTIONS = REMOVE_USER_SELECTIONS;
function REMOVE_LOADED_CABINS(state) {
    state.cabins = [];
}
exports.REMOVE_LOADED_CABINS = REMOVE_LOADED_CABINS;
function PREMIUM_SUPPORT(state, newState) {
    state.priceModelSupportsPremium = newState;
}
exports.PREMIUM_SUPPORT = PREMIUM_SUPPORT;
function VARIOAI_SUPPORT(state, newState) {
    state.varioAISupport = newState;
}
exports.VARIOAI_SUPPORT = VARIOAI_SUPPORT;
function RESET_STATE(state) {
    state.cabinAutoReset = false;
    state.cabinCategories = [];
    state.cabinCategory = null;
    state.cabins = [];
    state.decks = [];
    state.loadingCabinCategories = '';
    state.loadingCabins = '';
    state.loadingRequiredCabin = {
        cabinNumber: null,
        lastFoundCabinNumberForScrollingIntoView: null,
        message: {
            header: '',
            level: 'warning',
            message: '',
            reference: 'cabin',
            type: 'validation',
        },
    };
    state.activeAdditionalCategory = 'NONE';
    state.selectionCategoryConfigurations = [];
    state.priceDiffers = [];
    state.priceModelSupportsPremium = true;
}
exports.RESET_STATE = RESET_STATE;
function SET_SELECTED_BY_OTHER_STORES(state, newState) {
    state.selectedByOtherStores = newState;
}
exports.SET_SELECTED_BY_OTHER_STORES = SET_SELECTED_BY_OTHER_STORES;
function SET_CABIN_AUTO_RESET(state, newState) {
    state.cabinAutoReset = newState;
}
exports.SET_CABIN_AUTO_RESET = SET_CABIN_AUTO_RESET;
function FETCH_CATEGORIES_DONE(state, done) {
    state.fetchCategoriesDone = done;
}
exports.FETCH_CATEGORIES_DONE = FETCH_CATEGORIES_DONE;
function SET_LOW_CABIN_INFO(state, show) {
    var premiumConfigIndex = helper_1.default.getCurrentSelectionConfigurationIndex(state);
    state.selectionCategoryConfigurations[premiumConfigIndex].lowCabinInfo = show;
}
exports.SET_LOW_CABIN_INFO = SET_LOW_CABIN_INFO;
exports.default = {
    SET_CABIN_CATEGORIES: SET_CABIN_CATEGORIES,
    SELECT_MAIN_CABIN_CATEGORY: SELECT_MAIN_CABIN_CATEGORY,
    SET_ACTIVE_ADDITIONAL_CATEGORY_STATE: SET_ACTIVE_ADDITIONAL_CATEGORY_STATE,
    SET_LOADING_CABIN_CATEGORIES: SET_LOADING_CABIN_CATEGORIES,
    SET_AVAILABLE_CABIN_CATEGORIES: SET_AVAILABLE_CABIN_CATEGORIES,
    SET_CABIN_CATEGORY_PRICE: SET_CABIN_CATEGORY_PRICE,
    SET_SELECTION_CATEGORY_CONFIGURATION: SET_SELECTION_CATEGORY_CONFIGURATION,
    SET_PREMIUM_CABIN_CATEGORY: SET_PREMIUM_CABIN_CATEGORY,
    SET_PREMIUM_CABIN_SHIP_SECTION: SET_PREMIUM_CABIN_SHIP_SECTION,
    SET_PREMIUM_CABIN_DECK: SET_PREMIUM_CABIN_DECK,
    SET_PREMIUM_CABIN_CABIN: SET_PREMIUM_CABIN_CABIN,
    SET_PREMIUM_CABIN_STEP: SET_PREMIUM_CABIN_STEP,
    SET_PREMIUM_CABIN_STEP_PREVIOUS: SET_PREMIUM_CABIN_STEP_PREVIOUS,
    SET_PREMIUM_CABIN_STEP_NEXT: SET_PREMIUM_CABIN_STEP_NEXT,
    SET_LOADING_CABINS: SET_LOADING_CABINS,
    SET_CABINS: SET_CABINS,
    SET_LOADING_REQUIRED_CABIN_INFO: SET_LOADING_REQUIRED_CABIN_INFO,
    SET_LOADING_REQUIRED_CABIN_WAS_SCROLLED: SET_LOADING_REQUIRED_CABIN_WAS_SCROLLED,
    REMOVE_USER_SELECTIONS: REMOVE_USER_SELECTIONS,
    REMOVE_LOADED_CABINS: REMOVE_LOADED_CABINS,
    PREMIUM_SUPPORT: PREMIUM_SUPPORT,
    RESET_STATE: RESET_STATE,
    SET_SELECTED_BY_OTHER_STORES: SET_SELECTED_BY_OTHER_STORES,
    SET_CABIN_AUTO_RESET: SET_CABIN_AUTO_RESET,
    FETCH_CATEGORIES_DONE: FETCH_CATEGORIES_DONE,
    SET_LOW_CABIN_INFO: SET_LOW_CABIN_INFO,
    SET_LOADING_WISH_CABIN: SET_LOADING_WISH_CABIN,
    SET_MAIN_CABIN_CATEGORIES: SET_MAIN_CABIN_CATEGORIES,
    SET_DECKS: SET_DECKS,
    VARIOAI_SUPPORT: VARIOAI_SUPPORT
};
//# sourceMappingURL=mutations.js.map